<template>
  <div class="button" :class="{ 'loading': loading }">
    <template v-if="!loading">{{ text }}</template>
    <div class="loader" v-else><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
  export default {
    name: 'MangalButton',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      text: {
        type: String
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MangalButton.vue